import request from "./../utils/request";
import log2 from "../utils/log2";

const log = log2("WEBPHONE_TELNYX_API");

export const WEBPHONE_TELNYX_API = {
    balance: {
        /**
         * Hesap bakiye detaylarını getirir
         * @param {string} channelId - Telnyx kanal ID'si
         * @returns {Promise<object>} - Bakiye bilgileri
         */
        getDetail: (channelId) => {
            log("balance.getDetail", { channelId });
            return request({
                url: `/webphone/telnyx/${channelId}/balance`,
                method: "get",
            }).then((response) => response.data);
        },
    },

    phoneNumbers: {
        /**
         * Telefon numaralarını listeler
         * @param {string} channelId - Telnyx kanal ID'si
         * @param {object} filters - Filtreleme parametreleri
         * @returns {Promise<object>} - Telefon numaraları listesi
         */
        list: (channelId, filters = {}) => {
            log("phoneNumbers.list", { channelId, filters });
            return request({
                url: `/webphone/telnyx/${channelId}/phone-numbers`,
                method: "get",
                params: filters,
            }).then((response) => response.data);
        },
    },

    recordings: {
        /**
         * Call recordings kayıtlarını getirir
         * @param {string} channelId - Telnyx kanal ID'si
         * @param {object} filters - Filtreleme parametreleri
         * @returns {Promise<object>} - Recording kayıtları
         */
        list: (channelId, filters) => {
            log("recordings.list", { channelId, filters });
            return request.post(`/webphone/telnyx/${channelId}/recordings/list`, filters).then((response) => response.data);
        },

        /**
         * CDR listesi için alias - TelnyxCDR.vue uyumluluğu için
         * @param {string} channelId - Telnyx kanal ID'si
         * @param {object} filters - Filtreleme parametreleri
         * @returns {Promise<object>} - Recording kayıtları
         */
        getCDRList: (channelId, filters) => {
            log("recordings.getCDRList", { channelId, filters });
            return request.post(`/webphone/telnyx/${channelId}/recordings/list`, filters).then((response) => response.data);
        },

        /**
         * Arama kaydı medya dosyasının URL'ini getirir
         * @param {string} channelId - Telnyx kanal ID'si
         * @param {string} recordingId - Kayıt ID'si
         * @returns {Promise<object>} - Kayıt medya bilgileri
         */
        getMedia: (channelId, recordingId) => {
            log("recordings.getMedia", { channelId, recordingId });
            return request({
                url: `/webphone/telnyx/${channelId}/recordings/${recordingId}`,
                method: "get",
            }).then((response) => response.data);
        },
    },

    calls: {
        /**
         * Arama başlatır
         * @param {string} channelId - Telnyx kanal ID'si
         * @param {object} callData - Arama parametreleri
         * @returns {Promise<object>} - Arama başlatma sonucu
         */
        make: (channelId, callData) => {
            log("calls.make", { channelId, callData });
            return request.post(`/webphone/telnyx/${channelId}/calls`, callData).then((response) => response.data);
        },

        /**
         * Aramayı yanıtlar
         * @param {string} channelId - Telnyx kanal ID'si
         * @param {string} callControlId - Arama kontrol ID'si
         * @param {object} answerData - Yanıtlama parametreleri
         * @returns {Promise<object>} - Yanıtlama sonucu
         */
        answer: (channelId, callControlId, answerData = {}) => {
            log("calls.answer", { channelId, callControlId, answerData });
            return request.post(`/webphone/telnyx/${channelId}/calls/${callControlId}/answer`, answerData).then((response) => response.data);
        },

        /**
         * Aramayı sonlandırır
         * @param {string} channelId - Telnyx kanal ID'si
         * @param {string} callControlId - Arama kontrol ID'si
         * @param {object} hangupData - Sonlandırma parametreleri
         * @returns {Promise<object>} - Sonlandırma sonucu
         */
        hangup: (channelId, callControlId, hangupData = {}) => {
            log("calls.hangup", { channelId, callControlId, hangupData });
            return request.post(`/webphone/telnyx/${channelId}/calls/${callControlId}/hangup`, hangupData).then((response) => response.data);
        },

        /**
         * Aramayı transfer eder
         * @param {string} channelId - Telnyx kanal ID'si
         * @param {string} callControlId - Arama kontrol ID'si
         * @param {object} transferData - Transfer parametreleri
         * @returns {Promise<object>} - Transfer sonucu
         */
        transfer: (channelId, callControlId, transferData) => {
            log("calls.transfer", { channelId, callControlId, transferData });
            return request.post(`/webphone/telnyx/${channelId}/calls/${callControlId}/transfer`, transferData).then((response) => response.data);
        },

        recording: {
            /**
             * Arama kaydı başlatır
             * @param {string} channelId - Telnyx kanal ID'si
             * @param {string} callControlId - Arama kontrol ID'si
             * @param {object} recordData - Kayıt parametreleri
             * @returns {Promise<object>} - Kayıt başlatma sonucu
             */
            start: (channelId, callControlId, recordData = {}) => {
                log("calls.recording.start", { channelId, callControlId, recordData });
                return request.post(`/webphone/telnyx/${channelId}/calls/${callControlId}/recording/start`, recordData).then((response) => response.data);
            },

            /**
             * Arama kaydını durdurur
             * @param {string} channelId - Telnyx kanal ID'si
             * @param {string} callControlId - Arama kontrol ID'si
             * @returns {Promise<object>} - Kayıt durdurma sonucu
             */
            stop: (channelId, callControlId) => {
                log("calls.recording.stop", { channelId, callControlId });
                return request.post(`/webphone/telnyx/${channelId}/calls/${callControlId}/recording/stop`).then((response) => response.data);
            },
        },
    },

    connection: {
        /**
         * API bağlantısını test eder
         * @param {string} channelId - Telnyx kanal ID'si
         * @returns {Promise<object>} - Bağlantı durumu
         */
        test: (channelId) => {
            log("connection.test", { channelId });
            return request({
                url: `/webphone/telnyx/${channelId}/test-connection`,
                method: "get",
            }).then((response) => response.data);
        },
    },
}; 